"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APosLotteryLogLineSchema = exports.APosLotteryVoucherSchema = exports.APosLotteryMachineSchema = exports.APosLotteryTerminalReportSchema = exports.APosLotteryShiftCountSchema = exports.APosLotteryCountLineSchema = exports.APosLotteryBinSchema = exports.APosLotterySettingsSchema = exports.APosLotteryGamingPaidAsSchema = exports.APosLotteryBarcodeFormatSchema = exports.APosLotteryLineSchema = exports.APosLotteryPayoutCategorySchema = exports.APosLotteryLineKindSchema = void 0;
const zod_1 = require("zod");
exports.APosLotteryLineKindSchema = zod_1.z.enum(['scratch', 'draw', 'payout']);
exports.APosLotteryPayoutCategorySchema = zod_1.z.enum(['lottery-scratch', 'lottery-draw', 'gaming']);
/** Tag carried on a till cart line / stored transaction item. Money is NOT here (the line's unitPrice carries it, in dollars). */
exports.APosLotteryLineSchema = zod_1.z.object({
    kind: exports.APosLotteryLineKindSchema,
    payoutCategory: exports.APosLotteryPayoutCategorySchema.optional(), // required when kind === 'payout'
    gameId: zod_1.z.string().optional(),
    gameNumber: zod_1.z.string().optional(),
    gameName: zod_1.z.string().optional(),
    bookId: zod_1.z.string().optional(),
    packNumber: zod_1.z.string().optional(),
    ticketNumbers: zod_1.z.array(zod_1.z.string()).optional(), // scratch: scanned ticket numbers on this line
    binNumber: zod_1.z.number().int().optional(),
    machineId: zod_1.z.string().optional(),
    machineName: zod_1.z.string().optional(),
    voucherNumber: zod_1.z.string().optional(),
});
exports.APosLotteryBarcodeFormatSchema = zod_1.z.object({
    gameDigits: zod_1.z.number().int().min(1).max(8),
    packDigits: zod_1.z.number().int().min(1).max(10),
    ticketDigits: zod_1.z.number().int().min(1).max(5),
    totalLength: zod_1.z.number().int().min(18).max(32),
});
exports.APosLotteryGamingPaidAsSchema = zod_1.z.enum(['cash', 'store_credit', 'lottery', 'merchandise']);
exports.APosLotterySettingsSchema = zod_1.z.object({
    locationId: zod_1.z.string(),
    state: zod_1.z.string().default('GA'),
    barcode: exports.APosLotteryBarcodeFormatSchema.default({ gameDigits: 4, packDigits: 6, ticketDigits: 3, totalLength: 24 }),
    ticketDirection: zod_1.z.enum(['up', 'down']).default('up'),
    binCount: zod_1.z.number().int().min(1).max(64).default(16),
    autoSettleDays: zod_1.z.number().int().min(1).max(365).default(45),
    payoutLimitCents: zod_1.z.number().int().min(0).max(59999).default(59999),
    commission: zod_1.z.object({ salesPct: zod_1.z.number().min(0).max(20).default(5), cashingPct: zod_1.z.number().min(0).max(10).default(1) }).default({ salesPct: 5, cashingPct: 1 }),
    requireShiftCount: zod_1.z.boolean().default(true),
    gaming: zod_1.z.object({
        enabled: zod_1.z.boolean().default(false),
        allowedPaidAs: zod_1.z.array(exports.APosLotteryGamingPaidAsSchema).default(['cash']),
        maxVoucherCents: zod_1.z.number().int().min(0).default(50000),
    }).default({ enabled: false, allowedPaidAs: ['cash'], maxVoucherCents: 50000 }),
    updatedAt: zod_1.z.number().optional(),
    updatedBy: zod_1.z.string().optional(),
});
exports.APosLotteryBinSchema = zod_1.z.object({
    binNumber: zod_1.z.number().int().min(1),
    bookId: zod_1.z.string().nullable(),
    gameId: zod_1.z.string().nullable(),
    nextTicket: zod_1.z.number().int().min(0).nullable(),
    updatedAt: zod_1.z.number(),
});
exports.APosLotteryCountLineSchema = zod_1.z.object({
    binNumber: zod_1.z.number().int(),
    bookId: zod_1.z.string().nullable(),
    gameId: zod_1.z.string().nullable(),
    priceCents: zod_1.z.number().int().min(0),
    start: zod_1.z.number().int().min(0).nullable(),
    end: zod_1.z.number().int().min(0).nullable(),
    soldCount: zod_1.z.number().int().min(0),
    soldCents: zod_1.z.number().int().min(0),
    packChanges: zod_1.z.array(zod_1.z.object({ fromBookId: zod_1.z.string(), toBookId: zod_1.z.string(), remainderSold: zod_1.z.number().int().min(0) })).default([]),
});
exports.APosLotteryShiftCountSchema = zod_1.z.object({
    locationId: zod_1.z.string(),
    businessDate: zod_1.z.string(), // YYYY-MM-DD
    sessionId: zod_1.z.string(),
    registerId: zod_1.z.string().nullable(),
    employeeId: zod_1.z.string().nullable(),
    employeeName: zod_1.z.string().nullable(),
    lines: zod_1.z.array(exports.APosLotteryCountLineSchema),
    soldCents: zod_1.z.number().int(),
    rungUpCents: zod_1.z.number().int(),
    overShortCents: zod_1.z.number().int(), // rungUp - sold (negative = short)
    source: zod_1.z.enum(['till', 'office']),
    correctedBy: zod_1.z.string().optional(),
    createdAt: zod_1.z.number(),
    updatedAt: zod_1.z.number(),
});
exports.APosLotteryTerminalReportSchema = zod_1.z.object({
    locationId: zod_1.z.string(),
    businessDate: zod_1.z.string(),
    drawSalesCents: zod_1.z.number().int().min(0),
    cancelsCents: zod_1.z.number().int().min(0),
    cashesCents: zod_1.z.number().int().min(0),
    instantCashesCents: zod_1.z.number().int().min(0),
    photoKey: zod_1.z.string().optional(),
    enteredBy: zod_1.z.string(),
    updatedAt: zod_1.z.number(),
});
exports.APosLotteryMachineSchema = zod_1.z.object({
    machineId: zod_1.z.string(), // lgm_{uuid}
    locationId: zod_1.z.string(),
    name: zod_1.z.string().min(1).max(80),
    serial: zod_1.z.string().max(80).default(''),
    operatorName: zod_1.z.string().max(120).default(''),
    status: zod_1.z.enum(['active', 'out_of_service', 'removed']).default('active'),
    createdAt: zod_1.z.number(),
    updatedAt: zod_1.z.number(),
});
exports.APosLotteryVoucherSchema = zod_1.z.object({
    voucherId: zod_1.z.string(), // lgv_{uuid}
    locationId: zod_1.z.string(),
    businessDate: zod_1.z.string(),
    machineId: zod_1.z.string(),
    voucherNumber: zod_1.z.string(),
    amountCents: zod_1.z.number().int().min(1),
    paidAs: exports.APosLotteryGamingPaidAsSchema,
    transactionId: zod_1.z.string().optional(),
    payoutId: zod_1.z.string().optional(),
    creditEntryId: zod_1.z.string().optional(),
    customerId: zod_1.z.string().optional(),
    employeeId: zod_1.z.string().nullable(),
    registerId: zod_1.z.string().nullable(),
    createdAt: zod_1.z.number(),
});
/** Itemized log row for any lottery/gaming line or drawer payout (fed best-effort by the till). */
exports.APosLotteryLogLineSchema = zod_1.z.object({
    logId: zod_1.z.string(), // `${transactionId}#${lineId}` or `payout#${payoutId}`
    locationId: zod_1.z.string(),
    businessDate: zod_1.z.string(),
    kind: exports.APosLotteryLineKindSchema,
    payoutCategory: exports.APosLotteryPayoutCategorySchema.optional(),
    source: zod_1.z.enum(['sale', 'drawer_payout']),
    transactionId: zod_1.z.string().optional(),
    payoutId: zod_1.z.string().optional(),
    amountCents: zod_1.z.number().int(), // positive for sales, positive for payouts (kind tells direction)
    quantity: zod_1.z.number().int().min(1),
    lottery: exports.APosLotteryLineSchema,
    employeeId: zod_1.z.string().nullable(),
    registerId: zod_1.z.string().nullable(),
    createdAt: zod_1.z.number(),
});
//# sourceMappingURL=lottery-records.schema.js.map